<template>
  <div class="panelNagusia">
    <div class="ui breadcrumb">
      <a class="section" v-on:click="goTo('/dashboard')">Home</a>
      <i class="right angle icon divider"></i>
      <a class="active section" v-on:click="goTo('/billing')">Facturación</a>
    </div>
    <h1 class="ui header"><img class="ui image" src="../../assets/euro.png">
      <div class="content">Facturación</div>
    </h1>
    <div class="ui stackable">
      <div class="row">
        <div class="column">
          <h4 class="ui dividing header">Selecciona un periodo</h4>
        </div>
      </div>
      <div class="ui hidden divider"></div>
      <div class="row">
        <form class="ui form">
          <div class="four fields">
            <div class="field">
              <sui-input onfocus="(this.type='date')" onblur="(this.type='text')" icon='calendar'
                placeholder="Fecha Inicio" v-model="startDate" />
            </div>
            <div class="field">
              <sui-input onfocus="(this.type='date')" onblur="(this.type='text')" icon='calendar'
                placeholder="Fecha Fin" v-model="endDate" />
            </div>
          </div>
        </form>
      </div>
      <div class="row">
        <div class="column">
          <table class="ui very basic compact table">
            <thead>
              <tr>
                <th class="azpian"></th>
                <th class="right aligned">
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="client in clients" v-bind:key="client.key">
                <td>
                  <h4 class="ui image header">
                    <div class="content">
                      <div class="header">{{ client.name }}</div>
                    </div>
                  </h4>
                </td>
                <td>
                  <div v-for="btn in client.btns" v-bind:key="client.id" :id="btn.id" v-if="role == 'master'"
                    class="ui button right aligned" @click="btn.onClick()">{{ btn.name }}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { hapiickApi } from '@/api/hapiickApi';
import mm_sms_bil from '../../../static/mm_sms_bil.json'


export default {
  name: 'Billing',
  data() {
    return {
      clients: [
        {
          key: 'zeleris', name: 'Movistar',
          btns: [
            {
              id: 'btnFact', name: 'Facturación', onClick: () => { this.movistarBilling() },
            },
            {
              id: 'btnFactPD', name: 'Desglose', onClick: () => { this.movistarBillingPerDay() }
            }
          ]
        },
        {
          key: 'gls', name: 'GLS',
          btns: [
            {
              id: 'btnGlsFact', name: 'Facturación', onClick: () => { this.glsBilling() }
            }
          ]
        },
        {
          key: 'forumsport', name: 'Forum Sport',
          btns: [
            {
              id: 'btnFSSms', name: 'Facturación SMS ', onClick: () => { this.smsBilling('forumsport', 'btnFSSms') }
            },
          ]
        },
        {
          key: 'nacex', name: 'Nacex',
          btns: [
            {
              id: 'btnNacexsms', name: 'Facturación SMS ', onClick: () => { this.smsBilling('nacex', 'btnNacexsms') }
            },
          ]
        },
        {
          key: 'mediamarkt', name: 'MediaMarkt',
          btns: [
            {
              id: 'btnMMSms', name: 'Facturación SMS ', onClick: () => { this.smsByAptBilling('staffappmediamarkt', 'btnMMSms') }
            },
          ]
        }
      ],
      role: null,
      startDate: null,
      endDate: null
    }
  },
  created() {
    this.role = JSON.parse(localStorage.admin).role
  },
  methods: {
    movistarBilling() {
      if (!this.startDate || !this.endDate) {
        this.$swal.fire({
          type: 'info',
          title: 'Selecciona un periodo',
        })
      } else {
        let x = document.getElementById("btnFact");
        x.classList.add("loading");
        x.disabled = true;

        hapiickApi().get('/v1/billings/movistar?startDate=' + this.startDate + '&endDate=' + this.endDate)
          .then(response => {
            let x = document.getElementById("btnFact");
            x.classList.remove("loading");
            x.disabled = false;
            let { operations } = { ...response.data }
            this.generateMovistarExcel(operations)
          })
          .catch(response => {
            let x = document.getElementById("btnFact");
            x.classList.remove("loading");
            x.disabled = false;
          })
      }
    },
    movistarBillingPerDay() {
      if (!this.startDate || !this.endDate) {
        this.$swal.fire({
          type: 'info',
          title: 'Selecciona un periodo',
        })
      } else {
        let x = document.getElementById("btnFactPD");
        x.classList.add("loading");
        x.disabled = true;

        hapiickApi().get('/v1/billings/movistar-per-day?startDate=' + this.startDate + '&endDate=' + this.endDate)
          .then(response => {
            let x = document.getElementById("btnFactPD");
            x.classList.remove("loading");
            x.disabled = false;

            let { operations } = { ...response.data }
            this.generateMovistarPerDayExcel(operations)
          })
          .catch(response => {
            let x = document.getElementById("btnFactPD");
            x.classList.remove("loading");
            x.disabled = false;
          })
      }
    },
    formatearFecha(fecha) {
      let fechaObjeto = new Date(fecha);
      let dia = fechaObjeto.getDate().toString().padStart(2, '0');
      let mes = (fechaObjeto.getMonth() + 1).toString().padStart(2, '0');
      let año = fechaObjeto.getFullYear();
      return dia + '/' + mes + '/' + año;
    },
    generateMovistarExcel(operations) {
      let startDate = this.formatearFecha(this.startDate);
      let endDate = this.formatearFecha(this.endDate);

      let fechas = 'Fecha: ' + startDate + ' - ' + endDate;
      let headers = 'Codigo,Tienda,N Paquetes';
      let paq = '';

      const costs = [...operations[0].costs];
      for (let i = 0; i < costs.length; i++) {
        if (i == costs.length - 1) {
          paq = ',PAQUETES +' + (costs[i].range_min - 1);
        } else if (costs[i].range_min == 1) {
          paq = ',PAQUETES 0-' + costs[i].range_max;
        } else {
          paq = ',PAQUETES ' + costs[i].range_min + '-' + costs[i].range_max
        }
        headers += paq;
        paq = '';
      }
      headers += ',TOTAL';

      let data_csv = [];
      data_csv.push(fechas);
      data_csv.push(headers);
      data_csv.push(',,,2.25,1.85,1.65,');
      data_csv.push(',,,2.68,2.20,1.96,');

      let row = '';
      operations.forEach(function (op) {
        row = op.code_store + ',' + op.apt_name + ',' + op.n + ',';
        op.costs.forEach((b) => {
          row += b.cost + ',';
        }, this)
        row += op.total_cost
        data_csv.push(row)
      }, this)

      this.downloadCSV(data_csv.join("\n"), 'Movistar.csv')
    },
    generateMovistarPerDayExcel(operations) {
      let headers = 'Codigo,Tienda,Día,N Paquetes';

      let data_csv = [headers];
      let row = '';

      operations.forEach(function (op) {
        row = op.code_store + ',' + op.apt_name + ',' + op.day + ',' + op.n;
        data_csv.push(row)
      }, this)

      this.downloadCSV(data_csv.join("\n"), 'MovistarPorDia.csv')
    },
    glsBilling() {
      if (!this.startDate || !this.endDate) {
        this.$swal.fire({
          type: 'info',
          title: 'Selecciona un periodo',
        })
      } else {
        let x = document.getElementById("btnGlsFact");
        x.classList.add("loading");
        x.disabled = true;

        hapiickApi().get('/v1/billings/gls?startDate=' + this.startDate + '&endDate=' + this.endDate)
          .then(response => {
            let x = document.getElementById("btnGlsFact");
            x.classList.remove("loading");
            x.disabled = false;
            let { operations } = { ...response.data }
            this.generateGlsExcel(operations, this.startDate, this.endDate)
          })
          .catch(response => {
            let x = document.getElementById("btnGlsFact");
            x.classList.remove("loading");
            x.disabled = false;
          })
      }
    },
    generateGlsExcel(operations, startDate, endDate) {
      let headers = 'Tipo,Máquina,Codigo de barras,Fecha ultima actualizacion';

      let data_csv = [headers];
      let row = '';

      operations.forEach(function (op) {
        row = op.tipo + ',' + op.name + ',' + op.barcode + ',' + op.modified;
        data_csv.push(row)
      }, this)

      const filename = 'paquetesGLS_' + this.startDate.replace(/-/g, '') + '_' + this.endDate.replace(/-/g, '') + '.csv'
      this.downloadCSV(data_csv.join("\n"), filename)
    },

    smsBilling(client_key, btn_id) {
      if (!this.startDate || !this.endDate) {
        this.$swal.fire({
          type: 'info',
          title: 'Selecciona un periodo',
        })
      } else {
        let x = document.getElementById(btn_id);
        x.classList.add("loading");
        x.disabled = true;

        hapiickApi().get('/v1/billings/sms?startDate=' + this.startDate + '&endDate=' + this.endDate + '&client=' + client_key)
          .then(response => {
            let x = document.getElementById(btn_id);
            x.classList.remove("loading");
            x.disabled = false;
            let { count, smss, data } = { ...response.data }

            if (client_key === 'forumsport' || client_key === 'nacex') {
              this.generateSmsExcel(count, smss, data, this.startDate, this.endDate, client_key)
            }
          })
          .catch(response => {
            let x = document.getElementById(btn_id);
            x.classList.remove("loading");
            x.disabled = false;
          })
      }
    },

    generateSmsExcel(count, smss, data, startDate, endDate, client) {
      let data_csv = []

      let row = 'Período de Facturación,Sms Facturados,€/sms,Total'
      data_csv.push(row)
      row = this.formatearFecha(startDate) + '-' + this.formatearFecha(endDate) + ',' + count + ',' + data.price + ',' + (count * data.price)
      data_csv.push(row)
      row = ''
      data_csv.push(row)
      row = 'Remitente,Teléfono,Partes,Fecha,Texto'
      data_csv.push(row)
      smss.forEach(function (sms) {
        row = sms.sender + ',' + sms.phone + ',' + sms.parts + ',' + sms.created + ',"' + sms.text + '"';
        data_csv.push(row)
      }, this)

      const filename = client.charAt(0).toUpperCase() + client.slice(1) + '_SMS_' + this.startDate.replace(/-/g, '') + '_' + this.endDate.replace(/-/g, '') + '.csv'

      this.downloadCSV(data_csv.join("\n"), filename)
    },

    smsByAptBilling(client_key, btn_id) {
      if (!this.startDate || !this.endDate) {
        this.$swal.fire({
          type: 'info',
          title: 'Selecciona un periodo',
        })
      } else {
        let x = document.getElementById(btn_id);
        x.classList.add("loading");
        x.disabled = true;

        hapiickApi().get('/v1/billings/sms-mm/?startDate=' + this.startDate + '&endDate=' + this.endDate + '&admin_id=' + JSON.parse(localStorage.admin).id)
          .then(response => {
            let x = document.getElementById(btn_id);
            x.classList.remove("loading");
            x.disabled = false;
            let { data } = { ...response.data }

            if (client_key === 'staffappmediamarkt') {
              this.generateMMSmsExcel(data, this.startDate, this.endDate)
            }
          })
          .catch(response => {
            let x = document.getElementById(btn_id);
            x.classList.remove("loading");
            x.disabled = false;
          })
      }
    },

    generateMMSmsExcel(data, startDate, endDate) {
      let data_csv = []
      let row_number = 1
      let sms_total_grupo = ''
      let TOTAL = ''
      let n_apts = ''
      let n_sms = ''
      let total_price = ''
      let total_parts = data.reduce((sum, item) => sum + parseInt(item.parts), 0)

      let row = 'place_id;TIENDA;SMS;PRECIO/sms;TOTAL €;PRORRATEO'
      data_csv.push(row)
      row_number++

      row = `TOTAL TIENDAS; ;${total_parts};;;`
      let sms_total_tiendas = `C${row_number}`
      data_csv.push(row)
      row_number++

      data_csv.push(';;;;;')
      row_number++

      Object.values(mm_sms_bil).forEach(group => {
        let apts = data.filter(a => group.place_ids.includes(a.place_id))

        if ('Barakaldo' in group) {
          let barakaldo_place_ids = group.Barakaldo.join('+')
          let barakaldo_parts = apts.filter(b => group.Barakaldo.includes(b.place_id)).reduce((sum, item) => sum + parseInt(item.parts), 0);
          apts = apts.filter(b => !group.Barakaldo.includes(b.place_id))
          apts.push({ 'place_id': barakaldo_place_ids, 'name': 'Barakaldo', 'parts': barakaldo_parts })
        }

        let first = row_number
        apts.forEach(apt => {
          row = `${apt.place_id};${apt.name};${apt.parts};`
          row += (!group.prorate) ? `${group.price};=C${row_number}*D${row_number};` : ';;'
          data_csv.push(row)
          row_number++
        })
        let last = row_number - 1

        if (group.name === 'OTHERS') {
          sms_total_grupo = sms_total_grupo.slice(0, -1)
          TOTAL = 'RESTO TIENDAS'
          n_apts = ''
          n_sms = `"=${sms_total_tiendas}-SUMA(${sms_total_grupo})"`
          total_price = `=C${row_number}*D${row_number}`
        } else {
          sms_total_grupo += `C${row_number};`
          TOTAL = 'TOTAL'
          n_apts = apts.length
          n_sms = `=SUMA(C${first}:C${last})`
          total_price = (group.prorate) ? `=C${row_number}*D${row_number}` : `=SUMA(E${first}:E${last})`
        }

        row = `${TOTAL};${apts.length};${n_sms};${group.price};${total_price};`
        row += (group.prorate) ? `=E${row_number}/B${row_number}` : ''

        data_csv.push(row)
        row_number++

        data_csv.push(';;;;;')
        row_number++
      })

      const filename = 'Mediamarkt_SMS_' + this.startDate.replace(/-/g, '') + '_' + this.endDate.replace(/-/g, '') + '.csv'

      this.downloadCSV(data_csv.join("\n"), filename)
    },

    downloadCSV(csv, filename) {
      var csvFile;
      var downloadLink;

      if (window.Blob == undefined || window.URL == undefined || window.URL.createObjectURL == undefined) {
        alert("Your browser doesn't support Blobs");
        return;
      }

      csvFile = new Blob(["\uFEFF" + csv], {
        type: "text/csv; charset=utf-8"
      });
      downloadLink = document.createElement("a");
      downloadLink.download = filename;
      downloadLink.href = window.URL.createObjectURL(csvFile);
      downloadLink.style.display = "none";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      window.URL.revokeObjectURL(downloadLink.href);
    }

  }
}
</script>
<style scoped></style>


// WEBPACK FOOTER //
// src/components/Billing/billing.vue